import Api from "@/api/index"

const Financial = {
  namespaced: true,
  state: {
    allVrtTransactions: null,
    oneVrtTransaction: null,

    allVrtAcc: null,
    oneVrtAcc: null,

    allTransTypes: null,
    oneTransType: null,

    allEnvelopes: null,
    oneEnvelope: null,

    allPayments: null,
    onePayment: null,

    allCashes: null,
    oneCash: null,

    allChecks: null,
    oneCheck: null,

    allDeposits: null,
    oneDeposit: null,

    allReturnedChecks: null,
    oneReturnedCheck: null,

    allBills: null,
    oneBill: null,

    create_was_good: null,
    create_message: null,
    update_was_good: null,
    update_message: null,

    destroy_was_good: null,
    destroy_message: null,

    isErrorCreation: null,
    MsgErrorCreation: null,

    isErrorUpdate: null,
    MsgErrorUpdate: null,
  },
  mutations: {
    getFinancials(state, {items, kind}){
      switch (kind) {
        case 'vrt_transactions':
          state.allVrtTransactions = items  
          break;
        case 'vrt_accounts':
          state.allVrtAcc = items  
          break;
        case 'transaction_types':
          state.allTransTypes = items        
          break;
        case 'Envelope':
          state.allEnvelopes = items
          break;
        case 'Payment':
          state.allPayments = items
          break;
        case 'Cash':
          state.allCashes = items
          break;
        case 'Check':
          state.allChecks = items
          break;
        case 'Deposit':
          state.allDeposits = items
          break;
        case 'Bill':
          state.allBills = items
          break;
        case 'ReturnedCheck':
            state.allReturnedChecks = items
            break;
        default:
          break;
      }
    },

    getOneFinancial(state, {item, kind}){
      switch (kind) {
        case 'vrt_transactions':
          state.oneVrtTransaction = item  
          break;
        case 'vrt_accounts':
          state.oneVrtAcc = item  
          break;
        case 'transaction_types':
          state.oneTransType = item        
          break;
        case 'envelopes':
          state.oneEnvelope = item
          break;
        case 'payments':
          state.onePayment = item
          break;
        case 'cashes':
          state.oneCash = item
          break;
        case 'checks':
          state.oneCheck = item
          break;
        case 'deposits':
          state.oneDeposit = item
          break;
        case 'bills':
          state.oneBill = item
          break;
        case 'returned_checks':
            state.oneReturnedCheck = item
            break;
        default:
          break;
      }
    },

    pushFinancial(state, {item, kind}){
      if (state.allVrtTransactions != null && kind == 'vrt_transactions'){
        state.allVrtTransactions.push(item.data)  
      } else if (state.allVrtAcc != null && kind == 'vrt_accounts'){
        state.allVrtAcc.push(item.data)  
      } else if (state.allTransTypes != null && kind == 'transaction_types'){
        state.allTransTypes.push(item.data)        
      }
    },

    updateFinancial(state , {item, kind, id}){
      if (state.allVrtTransactions != null && kind == 'vrt_transactions'){
        state.allVrtTransactions[id] = (item.data)  
      } else if (state.allVrtAcc != null && kind == 'vrt_accounts'){
        state.allVrtAcc[id] = (item.data)  
      } else if (state.allTransTypes != null && kind == 'transaction_types'){
        state.allTransTypes[id] = (item.data)        
      }
    },

    removeFinancial(state, id){
      if (state.allVrtTransactions != null && kind == 'vrt_transactions'){
        let idx = state.allVrtTransactions.data.findIndex(vt => Number(vt.id) == Number(id))
        state.allVrtTransactions.data.splice(idx, 1)
      }
    },

    errorCreation(state, {isError, msg}){
      state.isErrorCreation = isError
      state.MsgErrorCreation = msg
      setTimeout(() => {
        state.isErrorCreation = null
      }, 200);
    },

    create_good(state, {kind, was_good, msg}){
      state.create_was_good = was_good
      state.create_message = msg
      setTimeout(() => {
        state.create_was_good = null
        // state.create_message = null
      }, 500);
    },
    update_good(state, {was_good, msg}){
      state.update_was_good = was_good
      state.update_message = msg
      setTimeout(() => {
        state.update_was_good = null
        // state.update_message = null
      }, 500);
    },

    destroy_good(state, {was_good, msg}){
      state.destroy_was_good = was_good
      state.destroy_message = msg
      setTimeout(() => {
        state.destroy_was_good = null
        // state.destroy_message = null
      }, 500);
    },

    errorUpdate(state, {isError, msg}){
      state.isErrorUpdate = isError
      state.MsgErrorUpdate = msg
      setTimeout(() => {
        state.isErrorUpdate = null
      }, 200);
    },

    cleanVrtTrans(state){
      state.allVrtTransactions = null
      state.oneEnvelope = null
      state.oneCheck = null
      state.oneDeposit = null
      // state.oneBill = null
    },

    clearoneVrtTrans(state){
      state.oneVrtTransaction = null
    }
  },
  actions:{
    index(context, {kind, filter}){
      Api.Financial.index(kind, filter)
        .then(response => response.data)
        .then(itemsB => {
          context.commit('getFinancials', {items: itemsB, kind: kind})
          // context.commit('', {message: '',status: false})
        }).catch(function(error) {
          console.log(error);
        })
    },

    create(context, {kind, newFinancial}){
      Api.Financial.create(kind, newFinancial)
        .then(response => response.data)
        .then(itemB => {
          // context.commit('pushFinancial', {item: itemB, kind: kind});
          context.commit('errorCreation', {isError: false, msg: ''})
        }).catch(function(error) {
          console.log(error);
          context.commit('errorCreation', {isError: true, msg: error.response.data.errors[0]})
        })
    },

    update(context, {kind, index, id, financial, next_actions}){
      return Api.Financial.update(kind, financial, id, next_actions)
        .then(response => response.data)
        .then(itemB => {
          // context.commit('updateFinancial', {item: itemB, kind: kind, id: index});
          context.commit('errorUpdate', {isError: false, msg: ''})
          return itemB
        }).catch(function(error) {
          console.log(error);
          context.commit('errorUpdate', {isError: true, msg: error.response.data.errors[0]})
        })
    },
    updateManyTransactions(context, {financials}){
      Api.Financial.updateManyTransactions(financials)
        .then(response => response.data)
        .then(itemB => {
          // context.commit('updateFinancial', {item: itemB, kind: kind, id: index});
          context.commit('errorUpdate', {isError: false, msg: ''})
        }).catch(function(error) {
          console.log(error);
          context.commit('errorUpdate', {isError: true, msg: error.response.data.errors[0]})
        })
    },

    //UPDATE NF NUMBER DE PRE INVOICED
    updateVrtTransBuyingNF(context, {financial}){
      Api.Order.updateInvoicedNF(financial, financial.id)
        .then(response => response.data)
        .then(item =>{
          context.commit('errorUpdate', {isError: false, msg: ''})
        }).catch(function(error){
          console.log(error);
          context.commit('errorUpdate', {isError: true, msg: error.response.data.errors[0]})
        })

    },

    // ENVELOPE
      indexEnvelope(context, filter){
        Api.Financial.indexEnvelope(filter)
          .then(response => response.data)
          .then(itemsB => {
            context.commit('getFinancials', {items: itemsB, kind: 'Envelope'})
            // context.commit('', {message: '',status: false})
          }).catch(function(error) {
            console.log(error);
          })
      },

      createEnvelope(context, {newFinancial}){
        Api.Financial.createEnvelope(newFinancial)
          .then(response => response.data)
          .then(itemB => {
            // context.commit('pushFinancial', {item: itemB, kind: kind});
            context.commit('create_good', {was_good: true, msg: 'success'})
          }).catch(function(error) {
            console.log(error);
            context.commit('create_good', {was_good: false, msg: error.response.data.errors[0]})
          })
      },

      updateEnvelope(context, {financial}){
        Api.Financial.updateEnvelope(financial)
          .then(response => response.data)
          .then(itemB => {
            // context.commit('updateFinancial', {item: itemB, kind: kind, id: index});
            context.commit('update_good', {was_good: true, msg: 'success'})
          }).catch(function(error) {
            console.log(error);
            context.commit('update_good', {was_good: false, msg: error.response.data.errors[0]})
          })
      },
      receiveEnvelope(context, {envelope_id}){
        Api.Financial.receiveEnvelope(envelope_id)
          .then(response => response.data)
          .then(itemB => {
            // context.commit('updateFinancial', {item: itemB, kind: kind, id: index});
            context.commit('update_good', {was_good: true, msg: 'success'})
          }).catch(function(error) {
            console.log(error);
            context.commit('update_good', {was_good: false, msg: error.response.data.errors[0]})
          })
      },
      updateWholeEnvelope(context, {financial}){
        Api.Financial.updateWholeEnvelope(financial)
          .then(response => response.data)
          .then(itemB => {
            // context.commit('updateFinancial', {item: itemB, kind: kind, id: index});
            context.commit('update_good', {was_good: true, msg: 'success'})
          }).catch(function(error) {
            console.log(error);
            context.commit('update_good', {was_good: false, msg: error.response.data.errors[0]})
          })
      },
    //

    // PAYMENT
      indexPayment(context){
        Api.Financial.indexPayment()
          .then(response => response.data)
          .then(itemsB => {
            context.commit('getFinancials', {items: itemsB, kind: 'Payment'})
            // context.commit('', {message: '',status: false})
          }).catch(function(error) {
            console.log(error);
          })
      },

      createPayment(context, {newFinancial}){
        Api.Financial.createPayment(newFinancial)
          .then(response => response.data)
          .then(itemB => {
            // context.commit('pushFinancial', {item: itemB, kind: kind});
            context.commit('create_good', {was_good: true, msg: 'success'})
          }).catch(function(error) {
            //console.log({error});
            context.commit('create_good', {was_good: false, msg: error.response.data.errors[0]})
          })
      },

      updatePayment(context, {financial}){
        Api.Financial.updatePayment(financial)
          .then(response => response.data)
          .then(itemB => {
            // context.commit('updateFinancial', {item: itemB, kind: kind, id: index});
            context.commit('update_good', {was_good: true, msg: 'success'})
          }).catch(function(error) {
            console.log(error);
            context.commit('update_good', {was_good: false, msg: error.response.data.errors[0]})
          })
      },
      destroyEnvelope(context, payment_id){
        Api.Financial.destroyEnvelope(payment_id)
          .then(response => response.data)
          .then(itemB => {
            // context.commit('updateFinancial', {item: itemB, kind: kind, id: index});
            context.commit('destroy_good', {was_good: true, msg: 'success'})
          }).catch(function(error) {
            console.error(error);
            console.error(`erro in modules DESTROY of PAYMENT`);
            context.commit('destroy_good', {was_good: false, msg: error.response.data.errors[0]})
          })
      },
    //

    // CASH
      indexCash(context){
        Api.Financial.indexCash()
          .then(response => response.data)
          .then(itemsB => {
            context.commit('getFinancials', {items: itemsB, kind: 'Cash'})
            // context.commit('', {message: '',status: false})
          }).catch(function(error) {
            console.log(error);
          })
      },

      createCash(context, {newFinancial}){
        Api.Financial.createCash(newFinancial)
          .then(response => response.data)
          .then(itemB => {
            // context.commit('pushFinancial', {item: itemB, kind: kind});
            context.commit('create_good', {was_good: true, msg: 'success'})
          }).catch(function(error) {
            console.log(error);
            context.commit('create_good', {was_good: false, msg: error.response.data.errors[0]})
          })
      },

      updateCash(context, {financial}){
        Api.Financial.updateCash(financial)
          .then(response => response.data)
          .then(itemB => {
            // context.commit('updateFinancial', {item: itemB, kind: kind, id: index});
            context.commit('update_good', {was_good: true, msg: 'success'})
          }).catch(function(error) {
            console.log(error);
            context.commit('update_good', {was_good: false, msg: error.response.data.errors[0]})
          })
      },
    //

    // CHECK
      indexCheck(context, filter){
        Api.Financial.indexCheck(filter)
          .then(response => response.data)
          .then(itemsB => {
            context.commit('getFinancials', {items: itemsB, kind: 'Check'})
            // context.commit('', {message: '',status: false})
          }).catch(function(error) {
            console.log(error);
          })
      },

      createCheck(context, {newFinancial}){
        Api.Financial.createCheck(newFinancial)
          .then(response => response.data)
          .then(itemB => {
            // context.commit('pushFinancial', {item: itemB, kind: kind});
            context.commit('create_good', {was_good: true, msg: 'success'})
          }).catch(function(error) {
            console.log(error);
            context.commit('create_good', {was_good: false, msg: error.response.data.errors[0]})
          })
      },

      updateCheck(context, {financial}){
        Api.Financial.updateCheck(financial)
          .then(response => response.data)
          .then(itemB => {
            // context.commit('updateFinancial', {item: itemB, kind: kind, id: index});
            context.commit('update_good', {was_good: true, msg: 'success'})
          }).catch(function(error) {
            console.log(error);
            context.commit('update_good', {was_good: false, msg: error.response.data.errors[0]})
          })
      },
      updateManyChecks(context, {financial}){
        Api.Financial.updateManyChecks(financial)
          .then(response => response.data)
          .then(itemB => {
            // context.commit('updateFinancial', {item: itemB, kind: kind, id: index});
            context.commit('update_good', {was_good: true, msg: 'success'})
          }).catch(function(error) {
            console.log(error);
            context.commit('update_good', {was_good: false, msg: error.response.data.errors[0]})
          })
      },
    //

    // DEPOSIT
      indexDeposit(context, filter){
        Api.Financial.indexDeposit(filter)
          .then(response => response.data)
          .then(itemsB => {
            context.commit('getFinancials', {items: itemsB, kind: 'Deposit'})
            // context.commit('', {message: '',status: false})
          }).catch(function(error) {
            console.log(error);
          })
      },

      createDeposit(context, {newFinancial}){
        Api.Financial.createDeposit(newFinancial)
          .then(response => response.data)
          .then(itemB => {
            // context.commit('pushFinancial', {item: itemB, kind: kind});
            context.commit('create_good', {was_good: true, msg: 'success'})
          }).catch(function(error) {
            console.log(error);
            context.commit('create_good', {was_good: false, msg: error.response.data.errors[0]})
          })
      },

      updateDeposit(context, {financial}){
        Api.Financial.updateDeposit(financial)
          .then(response => response.data)
          .then(itemB => {
            // context.commit('updateFinancial', {item: itemB, kind: kind, id: index});
            context.commit('update_good', {was_good: true, msg: 'success'})
          }).catch(function(error) {
            console.log(error);
            context.commit('update_good', {was_good: false, msg: error.response.data.errors[0]})
          })
      },
      updateManyDeposits(context, {financial}){
        Api.Financial.updateManyDeposits(financial)
          .then(response => response.data)
          .then(itemB => {
            // context.commit('updateFinancial', {item: itemB, kind: kind, id: index});
            context.commit('update_good', {was_good: true, msg: 'success'})
          }).catch(function(error) {
            console.log(error);
            context.commit('update_good', {was_good: false, msg: error.response.data.errors[0]})
          })
      },

      deleteDeposit(context, {financial}){
        return Api.Financial.deleteDeposit(financial)
          .then(response => response.data)
          .then(itemB => {
            // context.commit('updateFinancial', {item: itemB, kind: kind, id: index});
            // context.commit('update_good', {was_good: true, msg: 'success'})
            return itemB
          }).catch(function(error) {
            console.log(error);
            context.commit('update_good', {was_good: false, msg: error.response.data.errors[0]})
            throw Error(error)
          })
      },
    //

  // RETURNED CHECK
    indexReturnedCheck(context, filter){
      Api.Financial.indexReturnedCheck(filter)
        .then(response => response.data)
        .then(itemsB => {
          context.commit('getFinancials', {items: itemsB, kind: 'ReturnedCheck'})
          // context.commit('', {message: '',status: false})
        }).catch(function(error) {
          console.log(error);
        })
    },

    createReturnedCheck(context, {newFinancial}){
      Api.Financial.createReturnedCheck(newFinancial)
        .then(response => response.data)
        .then(itemB => {
          // context.commit('pushFinancial', {item: itemB, kind: kind});
          context.commit('create_good', {was_good: true, msg: 'success'})
        }).catch(function(error) {
          console.log(error);
          context.commit('create_good', {was_good: false, msg: error.response.data.errors[0]})
        })
    },

    updateReturnedCheck(context, {financial}){
      Api.Financial.updateReturnedCheck(financial)
        .then(response => response.data)
        .then(itemB => {
          // context.commit('updateFinancial', {item: itemB, kind: kind, id: index});
          context.commit('update_good', {was_good: true, msg: 'success'})
        }).catch(function(error) {
          console.log(error);
          context.commit('update_good', {was_good: false, msg: error.response.data.errors[0]})
        })
    },
  //

    // BILL
    indexBill(context, filter){
      Api.Financial.indexBill(filter)
        .then(response => response.data)
        .then(itemsB => {
          context.commit('getFinancials', {items: itemsB, kind: 'Bill'})
          // context.commit('', {message: '',status: false})
        }).catch(function(error) {
          console.log(error);
        })
    },

    createBill(context, {newFinancial}){
      Api.Financial.createBill(newFinancial)
        .then(response => response.data)
        .then(itemB => {
          // context.commit('pushFinancial', {item: itemB, kind: kind});
          context.commit('create_good', {was_good: true, msg: 'success'})
        }).catch(function(error) {
          console.log(error);
          context.commit('create_good', {was_good: false, msg: error.response.data.errors[0]})
        })
    },

    updateBill(context, {financial}){
      Api.Financial.updateBill(financial)
        .then(response => response.data)
        .then(itemB => {
          // context.commit('updateFinancial', {item: itemB, kind: kind, id: index});
          context.commit('update_good', {was_good: true, msg: 'success'})
        }).catch(function(error) {
          console.log(error);
          context.commit('update_good', {was_good: false, msg: error.response.data.errors[0]})
        })
    },
  //


    show(context, {kind, id}){
      Api.Financial.show(kind, id)
        .then(response => response.data)
        .then(itemB => {
          context.commit('getOneFinancial', {item: itemB, kind: kind});
          // context.commit('', {message: '',status: false})
        }).catch(function(error) {
          console.log(error);
        })
    },
    cleanVrtTrans(context){
      context.commit('cleanVrtTrans')
    },
    
    clearoneVrtTrans(context){
      context.commit('clearoneVrtTrans')
    }
  },
};

export default Financial;
